// @flow

export { getImageDimensions, getGeoPointFromExif } from './mediaUtils';

export {
  base64ToUint8Array,
  cropImageToJpegUrl,
  orientationValueToDegrees,
  photoOrientation,
  rotateImageIfNeeded,
  mediaType,
  checkMediaReady,
  getImageDataURL,
  restoreExifAndRotateIfNeeded,
} from './uploadUtils';

export {
  getVideoTrackingModule,
  getSizeWithMostPixels,
  supportedImageTypes,
  supportedVideoTypes,
  boundNumber,
  Point,
  Dimension,
} from './types';

export type { MediaSize, MediaType, CropOutput, PhotoInfo, GeoPoint } from './types';

export {
  default as VideoPlayerProvider,
  VideoPlayerConsumer,
  ActionTypes,
} from './VideoPlayerContext';

export {
  getMediaFilterToRetrieveAllPhotos,
  getMediaFilterToRetrieveDefaultPhotos,
} from './restrictedPartnerMedia';

export type { MediaFilter } from './restrictedPartnerMedia';
